/**
 * @module rectifyMediaCollectionType
 */

/**
 * Convenience function to rectify the media collection type name.
 *
 * Note: since there are parts still pulling data from v1 we will receive types with underscore.
 *
 * @param {string} type - The media collection type to be rectified.
 *
 * @returns {string} - The rectified collection type.
 */
function rectifyMediaCollectionType(type) {
  let modified = type;
  switch (type) {
    case 'weekend_message':
    case 'weekend-messages':
      modified = 'messages';
      break;
    case 'life_groups':
      modified = 'lifegroups';
      break;
    case 'leadership_podcast':
    case 'leadership-podcast':
      modified = 'leadershippodcast';
      break;
    case 'early_childhood':
    case 'early-childhood':
      modified = 'earlychildhood';
      break;
    case 'stories':
      modified = 'story';
      break;
    default:
      break;
  }
  return modified;
}

module.exports = {
  rectifyMediaCollectionType,
};
